<template>
  <div :title="$t('sectionModalRecord.clickToRecordAnAudio')">
    <button class="btn-text" @click="AbrirModal()">
      <i class="fas fa-microphone" aria-hidden="true"></i>
    </button>
    <b-modal
      v-model="abrir"
      :title="$t('sectionModalRecord.recordAnAudio')"
      hide-footer
    >
      <div v-if="loading" class="loading-container">
        <RotateSquare
          class="loading-position animated fadeIn"
          size="60px"
        ></RotateSquare>
      </div>
      <form v-else @submit="ValidarForm">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label>
                {{ $t("sectionModalRecord.recordWithComputerMicrophone") }}
              </label>
            </div>
          </div>
        </div>
        <div v-if="loadingAudio" class="row mb-3">
          <div class="col">
            <div class="form-inline">
              <label for="">{{
                $t("sectionModalRecord.recordingAudio")
              }}</label>
              <div class="loading-container ml-3">
                <RotateSquare size="20px"></RotateSquare>
              </div>
            </div>
          </div>
        </div>
        <div v-if="navegadorCompativel" class="row">
          <div class="col">
            <button
              class="btn btn-primary mr-2"
              :title="$t('sectionModalRecord.clickToStartRecordAnAudio')"
              type="button"
              @click="Iniciar()"
            >
              {{ $t("sectionModalRecord.init") }}
              <i class="fas fa-microphone ml-1"></i>
            </button>
            <button
              class="btn btn-warning mr-2"
              :title="$t('sectionModalRecord.clickToStopRecordAnAudio')"
              type="button"
              :disabled="!loadingAudio"
              @click="Parar()"
            >
              {{ $t("sectionModalRecord.stop") }}
              <i class="fas fa-stop ml-1" style="color: white;"> </i>
            </button>
            <button
              class="btn btn-success"
              type="submit"
              :title="$t('sectionModalRecord.clickToSendAudioContact')"
              :disabled="!viewModel.arquivo"
            >
              {{ $t("btEnviar") }}
              <i class="fas fa-share-square ml-1"></i>
            </button>
            
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import RotateSquare from "../../components/RotateSquare";
import MicRecorder from "mic-recorder-to-mp3";
import lamejs from 'lamejs';
import audiobufferToWav from 'audiobuffer-to-wav';

export default {
  name: "ModalRecord",
  components: { RotateSquare },
  props: {
    contatoId: {
      type: String,
      default: ""
    },
    evento: {
      type: String,
      default: ""
    },
    enumTipoContato:{
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      mediaRecorder: null,
      loadingAudio: false,
      loading: false,
      mediaStream: null,
      navegadorCompativel: true,
      viewModel: {
        descricao: "áudio",
        arquivo: null,
        contaId: this.$store.getters.getAutenticacao.contaSelecionadaId
      },
      abrir: false
    };
  },
  methods: {
     Parar() {
      let vm = this;
      this.mediaRecorder
        .stop()
        .getMp3()
        .then(([buffer, blob]) => {
          const audio = new File(buffer, "audio.mp3", {
            type: this.enumTipoContato === 3 ? "audio/mpeg":"audio/wav",
            lastModified: Date.now()
          });
          vm.viewModel.arquivo  = audio
          vm.loadingAudio = false;
        })
        .catch((e) => {
          console.error("erro start", e);

          const problemStoppingRecording = this.$t(
            "infoMessages.problemStoppingRecording"
          );
          const checkYourMicrophoneOnTheComputer = this.$t(
            "infoMessages.checkYourMicrophoneOnTheComputer"
          );

          vm.$notify({
            data: [problemStoppingRecording, checkYourMicrophoneOnTheComputer],
            type: "warn",
            duration: 10000
          });
        });   
    },
     Iniciar() {
      this.mediaRecorder = new MicRecorder({
        bitRate: 128
      });
       let vm = this;
      this.mediaRecorder
        .start()
        .then(() => {
          vm.loadingAudio = true;
        })
        .catch((e) => {
          console.error("erro start", e);
  
          const problemStartingRecording = this.$t(
            "infoMessages.problemStartingRecording"
          );
          const checkYourMicrophoneOnTheComputer = this.$t(
            "infoMessages.checkYourMicrophoneOnTheComputer"
      );
      
          vm.$notify({
            data: [problemStartingRecording, checkYourMicrophoneOnTheComputer],
            type: "warn",
            duration: 10000
          });
        });    

    },
    ValidarForm(evt) {
      evt.preventDefault();
      if (!this.viewModel.arquivo) {
        this.$notify({
          data: ["Áudio não gravado/reconhecido."],
          type: "warn",
          duration: 10000
        });
        return;
      }
      this.Novo();
    },
    Novo() {
      let formData = new FormData();
      formData.append("contaId", this.viewModel.contaId);
      formData.append("descricao", this.viewModel.descricao);
      formData.append("arquivo", this.viewModel.arquivo);
      this.loading = true;
      this.$http({
        url: "midia/novo-temporario",
        data: formData,
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
        .then((response) => {
          this.loading = false;
          this.Enviar(response.data);
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    },
    Enviar(arquivo) {
      this.$emit(this.evento, arquivo);
      this.abrir = false;
    },
    AbrirModal() {
      this.abrir = true;
      this.viewModel.contaId = this.$store.getters.getAutenticacao.contaSelecionadaId;
      this.viewModel.arquivo = null;
      this.ValidarCompatibilidadeNavegador();
    },
    AlertaNavegadorIncompativel() {
      const browserNotSupportedRecordAudio = this.$t(
        "infoMessages.browserNotSupportedRecordAudio"
      );
      const updateBrowser = this.$t("infoMessages.updateBrowser");

      this.$notify({
        data: [browserNotSupportedRecordAudio, updateBrowser],
        type: "warn",
        duration: 10000
      });
    },
    ValidarCompatibilidadeNavegador() {
      if (
        !navigator.mediaDevices ||
        !MediaRecorder.isTypeSupported("audio/webm")
      ) {
        this.navegadorCompativel = false;
        this.AlertaNavegadorIncompativel();
        return;
      }
    }
  }
};
</script>

<style lang="scss"></style>
